import { Component,  EventEmitter,  Input, OnInit, Output } from '@angular/core';
import { InformableSectionItem } from 'globals/store/informables.data';
import { publicHelpers } from '../../helpers/public-helpers';
import { Asset } from 'globals/store/assets.data';
import { FileLinkComponent } from '../file-handler/file-link.component';
import { AssetLinkComponent } from 'src/app/modules/assets/asset-link.component';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'expandable-info',
    template: `
<expanding-wrapper
  [initOpen]="!initClosed"
  [title]="item.name"
  [manualToggle]="manualToggle"
  [expandedState]="open ? 'expand' : 'collapse'"
  [borderDarkGreyOnCollapse]="!lightOnCollapse"
  [borderGreyOnCollapse]="lightOnCollapse"
  (onToggle)="onToggle.emit()"
>
  <div class="content">
    <div *ngIf="item.description" class="description" [innerHTML]="helpers.strWithBreak(item.description)"></div>
    <hr *ngIf="item.description && item.files?.length" />
    <h5 *ngIf="item.files?.length">FILES</h5>
    <div class="files" *ngIf="assets?.length">
      <h5 class="files_header">Assets</h5>
      <asset-link *ngFor="let asset of assets"
        (click)="$event.stopPropagation()"
        [asset]="asset"
        [onlyLink]="true"
      ></asset-link>
    </div>
    <file-link *ngFor="let file of item.files"
      [file]="file"
      [onlyLink]="true"
    ></file-link>
  </div>
</expanding-wrapper>
`,
    styleUrls: ['./expandable-info.scss'],
    standalone: true,
    imports: [FileLinkComponent, AssetLinkComponent, ExpandingWrapperComponent, CommonModule],
})
export class ExpandableInfoComponent implements OnInit {
  @Input() item: InformableSectionItem
  @Input() initClosed = true
  @Input() assets: Asset[]
  @Input() lightOnCollapse = false
  @Input() manualToggle = false
  @Input() open = false
  helpers = publicHelpers

  @Output() onToggle: EventEmitter<void> = new EventEmitter()


  ngOnInit() {
    this.open = !this.initClosed
  }


}


